import { HttpClient } from '@wix/http-client';
import { useAppStore } from '../stores/appStore';

const baseURL = window.location.origin + window.__BASEURL__;

const client = new HttpClient({ baseURL });

const ambassador = new HttpClient({
  createHeaders: () => {
    const msId = useAppStore.getState().msId;
    const headers: Record<string, string> = {};
    if (msId) {
      headers['x-wix-msid'] = msId;
    }
    return headers;
  },
});

export const httpUtils = {
  client,
  ambassador,
};
